<template>
  <div class="product-card" @click="handleLearnMore">
    <div class="product-image-container">
      <img :src="product.mainImage" :alt="product.productName" class="product-image" loading="lazy" />
    </div>
    <div class="product-content">
      <h3 class="product-name">{{ currentLanguage === 'en' ? product.productNameEn : product.productName }}</h3>
      <p class="product-description">{{ product.description }}</p>
      <div class="learn-more-btn">LEARN MORE <el-icon class="icon"><arrow-right /></el-icon></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  inject: ['currentLanguage'],
  methods: {
    handleLearnMore() {
      // 触发点击事件，父组件可以通过@learn-more监听
      this.$router.push('/product/' + this.product.id)
      const targetElement = document.querySelector('.navbar');
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
}
</script>

<style scoped>
.product-card {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 20px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  overflow: hidden;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  .learn-more-btn{
    transition: transform 1s ease;
    transform: translateX(20%);
  }
}

.product-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  width: 40%;
  height: 200px;
  flex-shrink: 0;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-content {
  text-align: left;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding-left: 20px;
  /* border-left: 1px solid #e6e6e6; */
}

.product-name {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 0 15px 0;
  color: #333;
  line-height: 1.3;
}

.product-description {
  font-size: 1rem;
  color: #666;
  margin: 0 0 20px 0;
  line-height: 1.6;
  display: -webkit-box;
  height: 48px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.learn-more-btn {
  background: none;
  border: none;
  color: #004a99;
  font-size: 0.9rem;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.learn-more-btn:hover {
  color: #0056b3;
  text-decoration: underline;
}

/* 小屏幕适配（小于等于768px） */
@media (max-width: 768px) {
  .product-card {
    flex-direction: column;
    align-items: center;
    padding: 15px;
    margin-bottom: 20px;
  }
  
  .product-image-container {
    width: 100%;
    height: 160px;
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .product-content {
    width: 100%;
  }
  
  .product-name {
    font-size: 1.3rem;
    margin-bottom: 10px;
  }
  
  .product-description {
    font-size: 0.9rem;
    margin-bottom: 15px;
    -webkit-line-clamp: 2;
  }
  
  .learn-more-btn {
    font-size: 0.85rem;
  }
}

/* 中屏幕适配（769px - 1100px） */
@media (min-width: 769px) and (max-width: 1100px) {
  .product-card {
    padding: 18px;
    margin-bottom: 25px;
  }
  
  .product-image-container {
    width: 35%;
    height: 180px;
  }
  
  .product-content {
    width: 65%;
  }
  
  .product-name {
    font-size: 1.4rem;
  }
  
  .product-description {
    -webkit-line-clamp: 3;
  }
}
</style>